@if (isActive && userNotification) {
  <div class="user-notification-banner" [title]="userNotification.Content ?? ''">
    <div class="user-notification-banner__border user-notification-banner__border--top"></div>
    <div class="user-notification-banner__content">
      <span class="user-notification-banner__text">{{ userNotification.Content }}</span>
    </div>
    <div class="user-notification-banner__border user-notification-banner__border--bottom"></div>
  </div>
}
